import type { JSX } from 'react';
import { Controller, FieldValues, Path, PathValue } from 'react-hook-form';

import { FormFieldWrapperProps } from '@/widgets/ServiceFormTemplate';

import { PhoneInputOwnProps, InputPhone } from '@/shared/ui';

type Props<T extends FieldValues> = Omit<PhoneInputOwnProps, 'defaultValue'> &
  FormFieldWrapperProps<T> & {
    defaultValue?: PathValue<T, Path<T>>;
  };

export function FormInputPhone<T extends FieldValues = FieldValues>({
  name,
  control,
  errorMessage,
  onChange,
  defaultValue,
  ...restProps
}: Props<T>): JSX.Element {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error: fieldError } }): JSX.Element => (
        <InputPhone
          {...field}
          onChange={(phoneValue, event): void => {
            const countryCode = phoneValue?.countryCode?.toString() ?? '';
            const areaCode = phoneValue?.areaCode ?? '';
            const phoneNumber = phoneValue.phoneNumber ?? '';
            field.onChange((countryCode ? `+${countryCode}` : '') + areaCode + phoneNumber);
            onChange?.(phoneValue, event);
          }}
          errorMessage={fieldError?.message || errorMessage}
          {...restProps}
        />
      )}
    />
  );
}
